<template>
  <div>
    <div
      v-if="component.type === 'text' && component.options.hidden === false"
      class=""
    >
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="box-Form-Sum">
        <p
          v-for="(item, index) in dataFormInputAll"
          :key="index"
          class="th pd-x-10 pd-y-10 line-h-5"
        >
          <span
            v-if="
              typeof item.input[component.name] !== 'undefined' &&
              item.input[component.name] !== null &&
              item.input[component.name] !== ''
            "
            >{{ item.input[component.name] }}</span
          >
          <i v-else>{{ $t("form.notFoundFormData") }}</i>
        </p>
      </div>
    </div>
    <div v-if="component.type === 'textarea'">
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="box-Form-Sum">
        <p
          v-for="(item, index) in dataFormInputAll"
          :key="index"
          class="th pd-x-10 pd-text-a line-h-5 p-bd-b"
        >
          <span
            v-if="
              typeof item.input[component.name] !== 'undefined' &&
              item.input[component.name] !== null &&
              item.input[component.name] !== ''
            "
            >{{ item.input[component.name] }}</span
          >
          <i v-else>{{ $t("form.notFoundFormData") }}</i>
        </p>
      </div>
    </div>
    <div
      v-if="
        component.type === 'select' &&
        component.display.choice !== 'phoneNumber'
      "
    >
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="columns m-h-auto is-vcentered">
        <div class="column is-6">
          <Doughnut
            v-if="
              Math.max(
                ...getvalueDoughnutCharts(
                  getSelectValue(
                    component.display.choice,
                    component.display.value
                  ),
                  component.name
                )
              ) !== 0
            "
            :width="220"
            :height="220"
            :labels="
              getLabelDoughnutCharts(
                getSelectValue(
                  component.display.choice,
                  component.display.value
                )
              )
            "
            :bgColor="getColor()"
            :timeout="2"
            :numData="
              getvalueDoughnutCharts(
                getSelectValue(
                  component.display.choice,
                  component.display.value
                ),
                component.name
              )
            "
            :tooltipsOpen="true"
          />
          <Doughnut
            v-else
            :timeout="2"
            :width="220"
            :height="220"
            :labels="['Acheived', 'Deactive', 'In process']"
            :bgColor="['#209cee', '#b5b5b5', '#23d160']"
            :numData="[0, -1, 0]"
          />
        </div>
        <div class="column is-6">
          <div class="over-auto">
            <p
              v-for="(value, index) in getSelectValue(
                component.display.choice,
                component.display.value
              )"
              :key="index"
              class="th is-size-6 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
            >
              <b-icon
                pack="fas"
                icon="circle"
                :style="{ color: getColor()[index] }"
              ></b-icon>
              {{ value.label }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        component.type === 'select' &&
        component.display.choice === 'phoneNumber'
      "
      class=""
    >
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="box-Form-Sum">
        <p
          v-for="(item, index) in dataFormInputAll"
          :key="index"
          class="th pd-x-10 pd-y-10 line-h-5"
        >
          <span
            v-if="
              typeof item.input[component.name] !== 'undefined' &&
              typeof item.input[component.name].phoneNumber !== 'undefined'
            "
          >
            {{ item.input[component.name].formatInternational }}
          </span>
          <i v-else>{{ $t("form.notFoundFormData") }}</i>
        </p>
      </div>
    </div>
    <div v-if="component.type === 'file'">
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="box-Form-Sum">
        <div
          v-for="(item, index) in dataFormInputAll"
          :key="index"
          class="th pd-x-10 pd-text-a line-h-5 p-bd-b"
        >
          <div
            v-if="
              typeof item.input[component.name] !== 'undefined' &&
              item.input[component.name] !== null &&
              typeof item.input[component.name][0] !== 'undefined'
            "
          >
            <div
              v-for="(item, index) in item.input[component.name]"
              :key="index"
            >
              <p>{{ item.name }}</p>
            </div>
          </div>
          <div
            v-else-if="
              typeof item.input[component.name] !== 'undefined' &&
              item.input[component.name] !== null
            "
          >
            {{ item.input[component.name].name }}
          </div>
          <i v-else>{{ $t("form.notFoundFormData") }}</i>
        </div>
      </div>
    </div>
    <div v-if="component.type === 'date'">
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="box-Form-Sum">
        <p
          v-for="(item, index) in dataFormInputAll"
          :key="index"
          class="th pd-x-10 pd-y-10 line-h-5"
        >
          <span
            v-if="
              typeof item.input[component.name] !== 'undefined' &&
              item.input[component.name] !== null &&
              item.input[component.name] !== ''
            "
            >{{ dateFomat(item.input[component.name]) }}</span
          >
          <i v-else>{{ $t("form.notFoundFormData") }}</i>
        </p>
      </div>
    </div>
    <div v-if="component.type === 'radio'">
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="columns m-h-auto is-vcentered">
        <div class="column is-6">
          <Doughnut
            v-if="
              Math.max(
                ...getvalueRadioDoughnutCharts(
                  component.display.value,
                  component.name
                )
              ) !== 0
            "
            :width="220"
            :height="220"
            :timeout="2"
            :labels="getLabelDoughnutCharts(component.display.value)"
            :bgColor="getColor()"
            :numData="
              getvalueRadioDoughnutCharts(
                component.display.value,
                component.name
              )
            "
            :tooltipsOpen="true"
          />
          <Doughnut
            v-else
            :width="220"
            :height="220"
            :timeout="2"
            :labels="['Acheived', 'Deactive', 'In process']"
            :bgColor="['#209cee', '#b5b5b5', '#23d160']"
            :numData="[0, -1, 0]"
          />
        </div>
        <div class="column is-6">
          <p
            v-for="(value, index) in component.display.value"
            :key="index"
            class="th is-size-6 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
          >
            <b-icon
              pack="fas"
              icon="circle"
              :style="{ color: getColor()[index] }"
            ></b-icon>
            {{ value.label }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="component.type === 'checkbox'">
      <p class="th is-size-6 pd-l-20 has-text-weight-normal">
        {{ component.display.label }}({{ dataFormInputAll.length }})
      </p>
      <div class="columns m-h-auto">
        <div class="column is-6">
          <BarCharts
            v-if="
              Math.max(
                ...getvalueBarCharts(component.display.value, component.name)
              ) !== 0
            "
            :height="220"
            :width="450"
            :bgColor="'#6d8df3'"
            :timeout="2"
            :labels="getLabelBarCharts(component.display.value)"
            :numData="
              getvalueBarCharts(component.display.value, component.name)
            "
            :maxY="
              Math.max(
                ...getvalueBarCharts(component.display.value, component.name)
              )
            "
            :tooltipsOpen="true"
          />
          <BarCharts
            v-else
            :height="220"
            :width="450"
            :bgColor="'#6d8df3'"
            :timeout="2"
            :labels="getLabelBarCharts(component.display.value)"
            :numData="
              getvalueBarCharts(component.display.value, component.name)
            "
            :maxY="3"
            :tooltipsOpen="true"
          />
        </div>
        <div class="column is-6">
          <p
            v-for="(value, index) in component.display.value"
            :key="index"
            class="th is-size-6 pd-x-5"
          >
            {{ index + 1 }}. {{ value.label }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Doughnut from "../../charts/Doughnut";
import BarCharts from "../../charts/BarCharts";
export default {
  components: {
    Doughnut,
    BarCharts,
  },
  props: ["component", "dataFormInputAll"],
  methods: {
    getSelectValue(choice, value) {
      if (choice === "custom") {
        return value;
      } else if (choice === "country") {
        return this.$store.getters.getCountryDynamic;
      } else if (choice === "province") {
        return this.$store.getters.getProvinceDynamic;
      } else {
        return [];
      }
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "-";
      } else {
        res = this.$moment(date).format("DD-MM-YYYY");
      }
      return res;
    },
    getLabelBarCharts(x) {
      let labelX = [];
      x.map((item, index) => {
        labelX.push(index + 1);
      });
      return labelX;
    },
    getvalueBarCharts(value, name) {
      let data = [];
      value.map((item) => {
        let count = 0;
        this.dataFormInputAll.map((value) => {
          let filter = [];
          if (typeof value.input[name] !== "undefined") {
            filter = value.input[name].filter(
              (startup) => startup.label === item.label
            );
          }
          count = count + filter.length;
        });
        data.push(count);
      });
      return data;
    },
    getLabelDoughnutCharts(x) {
      let labelX = [];
      x.map((item, index) => {
        labelX.push(item.label);
      });
      return labelX;
    },
    getvalueDoughnutCharts(value, name) {
      let data = [];

      value.map((item) => {
        // if (typeof value.input[name] !== 'undefined') {
        let filter = this.dataFormInputAll.filter((x) => {
          return (
            typeof x.input[name] !== "undefined" &&
            x.input[name] !== null &&
            x.input[name].label === item.label
          );
        });

        data.push(filter.length);
        // }
      });
      return data;
    },
    getvalueRadioDoughnutCharts(value, name) {
      let data = [];

      value.map((item) => {
        // if (typeof value.input[name] !== 'undefined') {
        let filter = this.dataFormInputAll.filter((x) => {
          return (
            typeof x.input[name] !== "undefined" &&
            x.input[name].data !== null &&
            x.input[name].data.label === item.label
          );
        });

        data.push(filter.length);
        // }
      });
      return data;
    },
    getColor() {
      var colorArray = [
        "#209cee",
        "#23d160",
        "#63b598",
        "#ce7d78",
        "#ea9e70",
        "#a48a9e",
        "#c6e1e8",
        "#648177",
        "#0d5ac1",
        "#f205e6",
        "#1c0365",
        "#14a9ad",
        "#4ca2f9",
        "#a4e43f",
        "#d298e2",
        "#6119d0",
        "#d2737d",
        "#c0a43c",
        "#f2510e",
        "#651be6",
        "#79806e",
        "#61da5e",
        "#cd2f00",
        "#9348af",
        "#01ac53",
        "#c5a4fb",
        "#996635",
        "#b11573",
        "#4bb473",
        "#75d89e",
        "#2f3f94",
        "#2f7b99",
        "#da967d",
        "#34891f",
        "#b0d87b",
        "#ca4751",
        "#7e50a8",
        "#c4d647",
        "#e0eeb8",
        "#11dec1",
        "#289812",
        "#566ca0",
        "#ffdbe1",
        "#2f1179",
        "#935b6d",
        "#916988",
        "#513d98",
        "#aead3a",
        "#9e6d71",
        "#4b5bdc",
        "#0cd36d",
        "#250662",
        "#cb5bea",
        "#228916",
        "#ac3e1b",
        "#df514a",
        "#539397",
        "#880977",
        "#f697c1",
        "#ba96ce",
        "#679c9d",
        "#c6c42c",
        "#5d2c52",
        "#48b41b",
        "#e1cf3b",
        "#5be4f0",
        "#57c4d8",
        "#a4d17a",
        "#225b8",
        "#be608b",
        "#96b00c",
        "#088baf",
        "#f158bf",
        "#e145ba",
        "#ee91e3",
        "#05d371",
        "#5426e0",
        "#4834d0",
        "#802234",
        "#6749e8",
        "#0971f0",
        "#8fb413",
        "#b2b4f0",
        "#c3c89d",
        "#c9a941",
        "#41d158",
        "#fb21a3",
        "#51aed9",
        "#5bb32d",
        "#807fb",
        "#21538e",
        "#89d534",
        "#d36647",
        "#7fb411",
        "#0023b8",
        "#3b8c2a",
        "#986b53",
        "#f50422",
        "#983f7a",
        "#ea24a3",
        "#79352c",
        "#521250",
        "#c79ed2",
        "#d6dd92",
        "#e33e52",
        "#b2be57",
        "#fa06ec",
        "#1bb699",
        "#6b2e5f",
        "#64820f",
        "#1c271",
        "#21538e",
        "#89d534",
        "#d36647",
        "#7fb411",
        "#0023b8",
        "#3b8c2a",
        "#986b53",
        "#f50422",
        "#983f7a",
        "#ea24a3",
        "#79352c",
        "#521250",
        "#c79ed2",
        "#d6dd92",
        "#e33e52",
        "#b2be57",
        "#fa06ec",
        "#1bb699",
        "#6b2e5f",
        "#64820f",
        "#1c271",
        "#9cb64a",
        "#996c48",
        "#9ab9b7",
        "#06e052",
        "#e3a481",
        "#0eb621",
        "#fc458e",
        "#b2db15",
        "#aa226d",
        "#792ed8",
        "#73872a",
        "#520d3a",
        "#cefcb8",
        "#a5b3d9",
        "#7d1d85",
        "#c4fd57",
        "#f1ae16",
        "#8fe22a",
        "#ef6e3c",
        "#243eeb",
        "#1dc18",
        "#dd93fd",
        "#3f8473",
        "#e7dbce",
        "#421f79",
        "#7a3d93",
        "#635f6d",
        "#93f2d7",
        "#9b5c2a",
        "#15b9ee",
        "#0f5997",
        "#409188",
        "#911e20",
        "#1350ce",
        "#10e5b1",
        "#fff4d7",
        "#cb2582",
        "#ce00be",
        "#32d5d6",
        "#17232",
        "#608572",
        "#c79bc2",
        "#00f87c",
        "#77772a",
        "#6995ba",
        "#fc6b57",
        "#f07815",
        "#8fd883",
        "#060e27",
        "#96e591",
        "#21d52e",
        "#d00043",
        "#b47162",
        "#1ec227",
        "#4f0f6f",
        "#1d1d58",
        "#947002",
        "#bde052",
        "#e08c56",
        "#28fcfd",
        "#bb09b",
        "#36486a",
        "#d02e29",
        "#1ae6db",
        "#3e464c",
        "#a84a8f",
        "#911e7e",
        "#3f16d9",
        "#0f525f",
        "#ac7c0a",
        "#b4c086",
        "#c9d730",
        "#30cc49",
        "#3d6751",
        "#fb4c03",
        "#640fc1",
        "#62c03e",
        "#d3493a",
        "#88aa0b",
        "#406df9",
        "#615af0",
        "#4be47",
        "#2a3434",
        "#4a543f",
        "#79bca0",
        "#a8b8d4",
        "#00efd4",
        "#7ad236",
        "#7260d8",
        "#1deaa7",
        "#06f43a",
        "#823c59",
        "#e3d94c",
        "#dc1c06",
        "#f53b2a",
        "#b46238",
        "#2dfff6",
        "#a82b89",
        "#1a8011",
        "#436a9f",
        "#1a806a",
        "#4cf09d",
        "#c188a2",
        "#67eb4b",
        "#b308d3",
        "#fc7e41",
        "#af3101",
        "#ff065",
        "#71b1f4",
        "#a2f8a5",
        "#e23dd0",
        "#d3486d",
        "#00f7f9",
        "#474893",
        "#3cec35",
        "#1c65cb",
        "#5d1d0c",
        "#2d7d2a",
        "#ff3420",
        "#5cdd87",
        "#a259a4",
        "#e4ac44",
        "#1bede6",
        "#8798a4",
        "#d7790f",
        "#b2c24f",
        "#de73c2",
        "#d70a9c",
        "#25b67",
        "#88e9b8",
        "#c2b0e2",
        "#86e98f",
        "#ae90e2",
        "#1a806b",
        "#436a9e",
        "#0ec0ff",
        "#f812b3",
        "#b17fc9",
        "#8d6c2f",
        "#d3277a",
        "#2ca1ae",
        "#9685eb",
        "#8a96c6",
        "#dba2e6",
        "#76fc1b",
        "#608fa4",
        "#20f6ba",
        "#07d7f6",
        "#dce77a",
        "#77ecca",
      ];
      return colorArray;
    },
  },
};
</script>
<style scoped>
.box-Form-Sum {
  height: 200px;
  border: 1px solid #d8d8d8 !important;
  border-radius: 5px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px;
  overflow-y: auto;
}
.line-h-5 {
  line-height: 20px;
}
.p-bd-b {
  border-bottom: 1px solid #d8d8d8;
}
.pd-text-a {
  padding-top: 20px;
  padding-bottom: 10px;
}
.box-Form-Sum::-webkit-scrollbar {
  display: unset !important;
  -webkit-appearance: none;
  width: 7px;
}
.box-Form-Sum::-webkit-scrollbar-thumb {
  -webkit-box-shadow: 0 0 1px rgba(216, 216, 216, 100%);
  background-color: rgba(216, 216, 216, 100%);
}
.box-Form-Sum::-webkit-scrollbar-track {
  display: none;
}
.box-Form-Sum::-webkit-scrollbar-track-piece {
  background-color: #f5f5f5;
}
i {
  color: #ccc;
}
.over-auto {
  height: 400px;
  overflow-y: auto;
}
</style>
